import React, { memo, useEffect, useState } from "react";
import { OroLoader, OroLoaderInline } from "../../core";
import { Button, Col, Input, Modal, ModalBody, ModalHeader, Progress, Row } from "reactstrap";
import MonthlyPaymentSchedule from "./MonthlyPaymentSchedule";
import WLTransactionHistory from "./WLTransactionHistory";
import UnderstandingAsset from "./UnderstandingAsset";
import WhyInvestNavi from "./WhyInvestNavi";
import ShowYTMModal from "./ShowYTMModal";
import { get } from "lodash";
import { utils } from "../../core/helpers/utils";
import ResourceFold from "./ResourceFold";
import MldMarketingFaq from "./MldMarketingFaq";
import { mldInvest } from "../assets/constants/mld-invest";
import InfoPopup from "./InfoPopup";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import giftBox from "../assets/images/Headline.png";
import ReactGA from "react-ga4";
import ConsultBanner from "./ConsultBanner";
import RiskInvolved from "./RiskInvolved";
import moment from "moment";
import VideoModal from "./VideoModal";
import { isMobile } from "react-device-detect";
import { getFaq, submitIntent } from "../services/waitlist-service";
import { ToastContainer, toast } from "react-toastify";
import { initializeGTM, sendGTMEvent } from "../../core/helpers/gtm";
import ReactPixel from "react-facebook-pixel";

const BondsAsset = memo(function BondsAsset(props) {
  const [issueList, setIssueList] = useState({});
  const [popUpOverText, setPopUpOverText] = useState("");
  const [showPopUpText, setShowPopupText] = useState(false);
  const [popUpOverLotText, setPopUpOverLotText] = useState('')
  const [showPopUpLotText, setShowPopupLotText] = useState(false);
  const [lotSize, setLotSize] = useState();
  const soldOut = props?.assetDetails?.soldOutTxt ? props.assetDetails.soldOutTxt : "0";
  const [preBookText, setPreBookText] = useState(true);
  const [disableInvestButton, setDisableInvestButton] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [learnVideoSrc, setLearnVideoSrc] = useState('');
  const [videoAnswer, setVideoAnswer] = useState('');
  const [videoQuestion, setVideoQuestion] = useState('');
  const [bondfaq, setBondFaq] = useState();
  const [result, setResult] = useState();
  const [genericFaq, setGenericFaq] = useState();
  const [isSection, setIsSection] = useState(true); // this page need faq sections
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    getFaq('bonds', props.product).then((response) => {
      if (!response.success) {
        return toast.error(response.message)
      } else {
        setBondFaq(response?.data?.questions)
      }
    })
  }, []);


  useEffect(() => {
    getFaq('bonds', 'generic').then((response) => {
      if (!response.success) {
        return toast.error(response.message)
      } else {
        setGenericFaq(response?.data?.questions)
      }
    })
  }, []);

  useEffect(() => {
    if(!isSection && bondfaq){
      // flat data without section
      const allContentArrays = bondfaq.map(item => item.content).flat();
      setResult(allContentArrays);
    } else {
      // data with section
      setResult(bondfaq); 
    }
  }, [bondfaq])

  useEffect(() => {
    const issueListTemp = [
      {
        point: "Coupon Payout",
        explaination: props?.assetDetails?.listing ? props.assetDetails.listing : "NA",
        learnMore: false,
        learnVideoSrc: 'https://www.youtube.com/embed/w95Ku5g95kQ?autoplay=1&mute=0&rel=0&controls=1&frameborder=0&modestbranding=0&showinfo=0',
      },
      {
        point: "Principal Repayment",
        explaination: props?.assetDetails?.principalRepayment ? props.assetDetails.principalRepayment : "NA"
      },
      {
        point: "Credit Rating",
        explaination: props?.assetDetails?.rating ? props.assetDetails.rating : "NA",
        learnMore: true,
        learnVideoSrc: 'https://www.youtube.com/embed/2Txp0E96u-4?autoplay=1&mute=0&rel=0&controls=1&frameborder=0&modestbranding=0&showinfo=0',
        videoQuestion: 'What are the Credit Ratings of Bonds?',
        videoAnswer: 'Understanding Bond Credit Ratings is crucial for smart investing. In this video, we will simplify this concept and its impact on your investment strategy. We will also learn about the rating criteria for bonds.'
      },
      {
        point: "Maturity Date",
        explaination: props?.assetDetails?.maturityDate ? moment(new Date(props.assetDetails.maturityDate).getTime()).format("Do MMM'YY") : "NA"
      },
      {
        point: "Security Cover",
        explaination: props?.assetDetails?.securityCover ? props.assetDetails.securityCover : "NA",
        // infoic: 'true',
        // popOvertext: "The Bond is secured by way of a first ranking, exclusive and continuing charge on identified loan receivables for 1.1x the outstanding amount of the Bond."
      },
      {
        point: "Min. Investment Amount",
        explaination: props?.assetDetails?.minAmt ? (props?.assetDetails?.minAmt).oroNumber(2, true) : "NA"
      },
      {
        point: "Clean Price",
        explaination: (props?.priceResponse?.accruedInterest !== undefined && props?.priceResponse?.Price)
          ? (props?.assetDetails?.product === "naviptc1" || props?.assetDetails?.product === "naviptc0" || props?.priceResponse?.accruedInterest === 0)
            ? (props?.priceResponse?.Price - (props?.priceResponse?.accruedInterest) / 10000).oroNumber(2, true)
            : (props?.priceResponse?.Price - props?.priceResponse?.accruedInterest).oroNumber(2, true)
          : "NA",
        learnMore: true,
        learnVideoSrc: 'https://www.youtube.com/embed/QR1tluTW-60?autoplay=1&mute=0&rel=0&controls=1&frameborder=0&modestbranding=0&showinfo=0',
        videoQuestion: 'Clean Price v/s Dirty Price',
        videoAnswer: 'Have you ever heard of clean price and dirty price but were not quite sure what they mean? In this video, we will break down these concepts in simple terms, so you can understand how bond prices are determined and how they impact your investments!'
      },
    ]
    setIssueList(issueListTemp);
  }, [props.assetDetails, props?.priceResponse]);

  useEffect(() => {
    initializeGTM();
    ReactPixel.init('1402347907589394');
    const locationHash = window.location.hash;
    ReactGA.send({ hitType: 'pageview', page_location: `${locationHash}` });
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent(locationHash, `${locationHash}`);
    }
  }, []);

  const handlelearnCLick = (src, que, ans) => {
    setLearnVideoSrc(src);
    setVideoQuestion(que);
    setVideoAnswer(ans);
    toggleVideoModal();
  }

  const handleVideoClick = (src, que, ans) => {
    setLearnVideoSrc(src);
    setVideoQuestion(que);
    setVideoAnswer(ans);
    toggleVideoModal();
  }

  useEffect(() => {
    let isNewJourney = props.isNewJourney;
    let isError = props?.errors?.length;
    let isTxnAllowed = props?.assetDetails?.enableInvestButton;
    let hvCug = props?.thirdPartyData.userInHypervergeCug;
    
    
    if (hvCug) {
      if(!props?.assetDetails?.enableInvestButton){
        return setDisableInvestButton(true);
      }
      if(props?.thirdPartyData.enhancedKycStaus === "retry" || props?.thirdPartyData.enhancedKycStaus === "pending" || props?.thirdPartyData.enhancedKycStaus === "rejected"){
        return setDisableInvestButton(false);
      }
      if(props?.thirdPartyData.enhancedKycStaus === "underProcess"){
        return setDisableInvestButton(true);
      }
      if(props?.thirdPartyData.enhancedKycStaus === "approved"){
        return setDisableInvestButton(false);
      }
    }
    
    if (!hvCug) {
      if (isNewJourney || isError) {
        return setDisableInvestButton(false);
      }
      if(!props?.isKycDone){
        return setDisableInvestButton(true)
      }
      if(props?.assetDetails?.userInRfqCug || props?.assetDetails?.enableInvestButton){
        return setDisableInvestButton(false);
      }
      if (isTxnAllowed) {
        return setDisableInvestButton(false);
      }
    }
    return setDisableInvestButton(true);
  }, [props])

  const getButtonText = () => {
    let hvCug = props?.thirdPartyData.userInHypervergeCug;
    let enhancedStatus = props?.thirdPartyData.enhancedKycStaus;
    let icmApproved = !props.errors?.length && props?.userState?.obUserApproved;
    let enhancedKYCStatuses = ["approved", "pending", "retry"];

    if (hvCug) {
      if (icmApproved) {
        if (props?.cvlValidate || enhancedKYCStatuses.includes(enhancedStatus)) {
          return "Invest Now"
        }
      }
      if (enhancedStatus === "underProcess") {
        return "KYC Under Process"
      }
      if ((enhancedStatus === "pending" || enhancedStatus === 'retry') && !icmApproved) {
        return "Get Started"
      }
      if (!icmApproved && (enhancedStatus === "pending" || enhancedStatus === 'retry')) {
        return "Get Started"
      } if (enhancedStatus === "rejected") {
        return "Re-initiate KYC"
      }
    } else if (!hvCug) {
      if (props?.isNewJourney) {
        return "Get Started"
      }
      if (props?.errors?.length) {
        return "Re-initiate KYC"
      } 
      if (icmApproved) {
        return "Invest Now"
      }
      if (!props?.isKycDone && !props.errors.length) {
        return "KYC Under Process"
      }
    } else {
      return "KYC Pending"
    }
  }

  const toggleVideoModal = () => {
    setShowVideo(!showVideo)
  }
  
  const handleCompleteNowClick = () => {
    sendGTMEvent("Bidd_Assest_Page_Get_Started_GTM", {email: props?.email || ""});
      ReactPixel.track("Bidd_Assest_Page_Get_Started_Pixel", {email: props?.email || ""});
    props.toggleHvInitiateModal();
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ 
          action: "BIDD_HV", 
          data: {
            assetCode: props?.assetDetails?.product,
            productType: props?.assetDetails?.productType
          }
        })
      )
    } else {
      return props.hypervergeVerification();
    }
  }

  const intentNow = async () => {
    try {
      debugger
      let payload = utils.getPKey() ? {
        payload: utils.encryptedPayload({
            "units": props?.assetDetails?.minUnits,
            "amount": props?.priceResponse?.userAmount,
            "status": true,
            "productType": props?.assetDetails?.productType
        })
    } : {
        "units": props?.assetDetails?.minUnits,
        "amount": props?.priceResponse?.userAmount,
        "status": true,
        "productType": props?.assetDetails?.productType
    };
      const headers = { "X-product": `orobonds:default` };
      const result1 = await submitIntent(props?.assetDetails?.ISIN ,headers, payload);
      const result = utils.parsePayload(result1);
      result?.message && toast.success(result?.message)
    } catch (e) {
      toast.error('Something went wrong : ', e);
    }
  }


  useEffect(() => {
    setLotSize((props?.assetDetails?.product == "naviptc0" || props?.assetDetails?.product == "naviptc1") ? 10000 : 1)
  }, [props?.assetDetails?.product])

  const progressStyle = {
    fontWeight: '800',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: "10px",
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
  }

  const barStyle = {
    borderRadius: '10px',
    color: "black",
  }

  const soldOutText = {
    fontSize: "12px",
    color: "black",
    marginTop: "-25px",
    fontWeight: "bold",
    marginBottom: "0"
  }

  const detailsButtons = [
    {
      label: "View Webinar",
      url: "",
      icon: "mdi mdi-play-circle mb-0 mr-1",
    },
    {
      label: "View Presentation",
      url: get(props?.assetDetails, "companyPresentationLink", ""),
      icon: "",
    }
  ]
  useEffect(() => {
    if (props?.assetDetails?.userInRfqCug && props?.ucc?.bse?.uccCreated) {
      const currentTime = moment();

      // Remmoved the check for weekends
      // if (currentTime.day() === 0 || currentTime.day() === 6) {
      //   setPreBookText(true);
      //   return;
      // }

      const openDate = moment(props?.assetDetails?.openDate);
      const marketStartTime = moment(props?.assetDetails?.marketStartTime, "HH:mm");
      const marketEndTime = moment(props?.assetDetails?.marketEndTime, "HH:mm");
      const closeDateTime = moment(`${props?.assetDetails?.closeDate} ${props?.assetDetails?.marketEndTime}`, "DD/MM/YYYY HH:mm");

      if (currentTime.isBefore(openDate)) {
        setPreBookText(true);
      } else if (currentTime.isAfter(openDate)) {
        if (currentTime.isBefore(marketStartTime) || currentTime.isAfter(marketEndTime)) {
          setPreBookText(true);
        } else {
          setPreBookText(false);
        }
      }

      if (currentTime.isAfter(closeDateTime)) {
        setPreBookText(true);
      }
    }else{
      setPreBookText(false);
    }
  }, [props?.assetDetails, props?.ucc]);


  useEffect(() => {
    setLotSize(props?.assetDetails?.product == "naviptc0" ? 10000 : 1)
  }, [props?.assetDetails?.product])

  const detailsBtnFunction = (url) => {
    window.open(url, "_blank", "noopener");
  }

  const handleInfoClick = (item, key) => {
    if (key || key === 0) {
      setPopUpOverText(item);
      setShowPopupText(!showPopUpText);
    }
  }

  const handleInfoLockedClick = () => {
    setShowPopupText(!showPopUpText)
    setPopUpOverText(`Available at a cost of 2% of the total amount liquidated. Refer <a className="text-secondary" target="_blank" href=${process.env.REACT_APP_URL_ENDPOINTS + "/terms-of-use/"}>T&C</a> for more details.`)
  }

  const handleLotSize = () => {
    setShowPopupLotText(!showPopUpLotText)
    setPopUpOverLotText(`1 Lot Size = 10,000 PTC Units`)
  }

  const increaseUnits = (product) => {
    props.increaseUnits();
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent("SI" + product + "UnitsAdded");
    }
  }

  const handleCouponClick = (product) => {
    props.setShowMonthlyPayment(true);
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent("SI" + product + "PaymentScheduled");
    }
  }

  useEffect(() => {
    const locationHash = window.location.hash;
    ReactGA.send({ hitType: 'pageview', page_location: `${locationHash}` });
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent(locationHash, `${locationHash}`);
    }
  }, [])

  return (
    props?.isAdvisory ? <></> :
    <>
      {!props.oroLoader && !props?.loader && !props?.loaderHyperverge ?
        <div>
          {props.loader && (
            <div className="mt-4">
              <OroLoaderInline />
            </div>
          )}

          <div ref={!props.isMobile ? props.investSectionRef : null}></div>
          {props.isMobile && <Col
            className={props?.assetDetails?.category !== "historical"
              ? "" : ""} lg={8}
            style={props?.isMobile ? { marginTop: "1rem" } : {}}
          >
            <p className={props?.assetDetails?.category == "historical"
              ? "main-title mb-0 text-left"
              : "main-title mb-0 text-left"}
              data-testid="title"
              style={(props?.isMobile && props?.portfolioValue?.data?.pfStats?.investedAmt)
                ? { marginTop: "5rem" } : { marginTop: "0" }}
            >
              {props.productDetails.displayName}
            </p>
            <p className="subtitle mb-0">{props?.assetDetails?.tagLine}</p>
          </Col>}
          <Row className="navi-first-fold">
            <Col
              className={props?.assetDetails?.category !== "historical"
                ? "" : ""} lg={8}
              style={props?.isMobile ? { marginTop: "1rem" } : {}}
            >
              {/* {(props?.isMobile && props?.assetDetails?.category != "historical") &&
                <p className={props?.assetDetails?.category === "historical" &&
                  (!props?.assetDetails.cugMode || !props?.assetDetails?.enableInvestButton) ? "main-title mb-0 text-center mt-2" : "main-title mb-0 mt-2"}
                  data-testid="title"
                  style={(props?.isMobile && props?.portfolioValue?.data?.pfStats?.investedAmt)
                    ? { marginTop: "4rem" } : { marginTop: "0" }}
                >
                  {props.productDetails.displayName}
                </p>
              } */}
              {(!props?.isMobile) &&
                <>
                <div className="d-flex align-items-center">
                  <img className="mr-2" src={props?.assetDetails?.logoUrl} style={{height: "45px", width: '45px'}}></img>
                  <p className={props?.assetDetails?.category === "historical" &&
                    (!props?.assetDetails.cugMode || !props?.assetDetails?.enableInvestButton) ? "main-title mb-0 " : "main-title mb-0"}
                    data-testid="title"
                    style={(props?.isMobile && props?.portfolioValue?.data?.pfStats?.investedAmt)
                      ? { marginTop: "4rem" } : { marginTop: "0" }}
                  >
                    {props.productDetails.displayName}
                  </p>
                </div>
                <p className="subtitle mb-0">{props?.assetDetails?.tagLine}</p>
                </>
              }
              {props?.assetDetails && props?.assetDetails.highlights &&
                props?.assetDetails.highlights.length 
                ? 
                  <div className={props?.assetDetails?.category === "historical" ? "bullets": "bullets"}>
                    {props?.assetDetails.highlights.map((item,index) => (
                      <div className="bullet" key={index}>
                        {
                          item.text === "Anytime Liquidity" ?
                            <p className="point">{item.text}
                              <span
                                onClick={handleInfoLockedClick}
                                className="mdi mdi-information-outline ml-2"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "15px",
                                }}
                              /></p> : <p className="point">{item.text}</p>
                        }
                      </div>
                    ))}
                  </div> 
                : null}
              {issueList && issueList.length &&
                <div className={props?.assetDetails?.category === "historical"
                  ? "points"
                  : "points"}
                >
                  {issueList?.map((item, key) => (
                    <div className={props?.assetDetails?.category === "historical" ? "cards" : 'cards'} key={key}>
                      <p className='first-text text-muted'>{item.point}
                        {item.infoic &&
                          <span
                            onClick={() => handleInfoClick(item.popOvertext, key)}
                            className="mdi mdi-information-outline ml-2"
                            style={{
                              cursor: "pointer",
                              fontSize: "15px",
                            }}
                          />
                        }
                      </p>
                      <p
                        className='second-text'
                        dangerouslySetInnerHTML={{ __html: item.explaination }}
                      />
                      {item.learnMore ? 
                        <p onClick={() => handlelearnCLick(item.learnVideoSrc, item.videoQuestion, item.videoAnswer)} className="learnmore">Learn More About {item.point} 
                          <span class="mdi mdi-play-circle"></span></p> 
                      : null}
                    </div>
                  ))}
                </div>
              }
              <div className='btn-holder'>
                {detailsButtons.map((item, index) =>
                  (item.url && item.url.length)
                    ? <Button
                      className={props?.assetDetails?.category === "historical" ? "details-btn m-auto" : "details-btn m-auto"}
                      onClick={() => detailsBtnFunction(item.url)}
                      key={index}
                    >
                      <span className={item.icon}></span>{item.label}
                    </Button>
                    : null
                )}
              </div>

              {props?.assetDetails?.category != "historical" && !isMobile ?
                <div className="video-div" 
                  onClick={() => handleVideoClick(
                    'https://www.youtube.com/embed/n-wXe7AdkJk?autoplay=1&mute=0&rel=0&controls=1&frameborder=0&modestbranding=0&showinfo=0',
                    'What are Corporate Bonds?',
                    'Confused about what corporate bonds are and how they work? In this video, we will break down corporate bonds in simple terms, so you can understand their benefits and how they play a vital role in your investment portfolio.'
                    )}
                >
                    <div className="left-col">
                        <p className="title">New to Corporate Bonds?</p>
                        <p className="subtext">Watch 1-min video to learn how bonds work️</p>
                    </div>
                    <div className="video-col">
                      <div className="video-inner">
                        <img src={process.env.REACT_APP_IMAGES_PATH + (props?.isMobile ? "Video-banner_1.webp" : "Video-banner.webp")} />
                        <div className="circle">
                          <span class="mdi mdi-play"></span>
                        </div>
                      </div>
                    </div>
                </div>
              : null}
            </Col>
            
            {props?.assetDetails && !props.assetDetails?.isProductAvailable ? (
    <div className="col-lg-4 asset-table pos-fixed">
      <div className="asset-content">
        <div className={`d-flex flex-column ${!props.assetDetails?.isProductAvailable ? "top-border" : ""}`}>
          <div className="assetContainerIntent">
            <p className="sharesNote mt-2">Coming soon!!</p>
            <img
              className="w-100"
              src={`${process.env.REACT_APP_IMAGES_PATH}Notify.webp`}
              alt="Notify"
            />
          </div>
          <Button onClick={intentNow} className="apply-btn">
            Notify me!
          </Button>
        </div>
      </div>
    </div>
  ) : (
  !props?.oroLoader &&
  !props?.loader && (
    <Col lg={4} className="p-3 asset-table">
      <div ref={props.isMobile ? props.investSectionRef : null}></div>
      <div className="mb-2">
        <Progress color="#EE5726" value={soldOut} />
      </div>
      <div className="soldout">
        <p className="soldOutText">{soldOut}% Sold out</p>
      </div>
      <div className="d-flex flex-column align-items-center">
        <p className={`font-weight-semi-bold ${!props.isMobile ? "navi-font-28" : "navi-font-24"}`}>
          Invest Now
        </p>
        <p className={`text-center mb-0 ${!props.isMobile ? "font-size-18" : "navi-font-14"}`}>
          <span>YTM for you: </span>
          <span className="text-primary">
            {get(props.priceResponse, "ytm", "") ? `${get(props.priceResponse, "ytm", "").toFixed(2)}% p.a.` : ""}
          </span>
          <span
            onClick={() => props.openModal(false)}
            style={{ cursor: "pointer", fontSize: "15px" }}
            className="mdi mdi-information-outline ml-2"
          />
          <br />
          {props?.assetDetails?.product !== "naviptc0" &&
          props?.assetDetails?.product !== "naviptc1" ? (
            <>
              <span>Current Price: </span>
              {get(props.priceResponse, "Price", "")
                ? `${get(props.priceResponse, "Price", "").oroNumber(2, true)} / unit`
                : ""}
              <span
                onClick={() => props.setShowFAQ(true)}
                style={{ cursor: "pointer", fontSize: "15px" }}
                className="mdi mdi-information-outline ml-2"
              />
            </>
          ) : (
            <>
              <span>Current Price: </span>
              {get(props.priceResponse, "Price", "")
                ? `${get(props.priceResponse, "Price", "").oroNumber(2, true)} / unit`
                : ""}
              <span
                onClick={() => props.setShowFAQ(true)}
                style={{ cursor: "pointer", fontSize: "15px" }}
                className="mdi mdi-information-outline ml-2"
              />
            </>
          )}
        </p>
        <div className="input">
          <p>Enter Units</p>
          <div className="flex-column ip">
            <div className="d-flex">
              <Button onClick={props.decreaseUnits}>-</Button>
              <Input
                style={props.units <= 0 ? { color: "#cfcfcf", fontSize: "12px" } : {}}
                value={props.units <= 0 ? "Enter Units" : props.units}
                onChange={(e) => props.setUnitsFunc(e.target.value)}
                pattern="[0-9]*"
                inputMode="numeric"
                placeholder="Enter Units"
                className="text-center"
              />
              <Button onClick={() => increaseUnits(props?.assetDetails?.product)}>+</Button>
            </div>
            <p className="text-danger text-center">{props?.inputValueError}</p>
          </div>
        </div>
        <div className="d-flex justify-content-between w-100 flex-column mb-2">
          <div className="d-flex justify-content-between w-100 mb-2">
            <div className="w-60">
              <p className={`mb-0 ${!props.isMobile ? "font-size-16" : "font-size-14"}`}>Total Investment</p>
            </div>
            <div className="w-40">
              <p
                className={`mb-0 ${!props.isMobile ? "font-size-16" : "navi-font-14"}`}
                style={{ textAlign: "end" }}
              >
                {props.units && props.priceResponse
                  ? `${props.priceResponse?.userAmount.oroNumber(2, true)}`
                  : "₹0"}
              </p>
            </div>
          </div>
          <div className="hr mb-4" />
          <div className="d-flex justify-content-between w-100 mb-2">
            <div className="w-60">
              <p className={`font-size-16 ${!props.isMobile ? "font-size-16" : "navi-font-14"}`}>
                Total Coupon Payout
              </p>
              {props?.productDetails?.couponType && (
                <p
                  onClick={() => handleCouponClick(props?.productDetails?.product)}
                  className="note"
                >
                  View payment schedule
                </p>
              )}
            </div>
            <div className="w-40">
              <p
                className={`text-align-end ${!props.isMobile ? "font-size-16" : "navi-font-14"}`}
              >
                {props.totalPayout ? props.totalPayout.oroNumber(2, true) : ""}
                
              </p>
            </div>
          </div>
          <div className="hr mb-4" />
          <div
                      className={
                        "d-flex justify-content-between w-100 " +
                        (!props.isMobile ? "mb-3" : "mb-2")
                      }
                    >
                      <div className="w-60">
                        <p className={!props.isMobile ? "font-size-16" : "navi-font-14"}>
                          {"Amount till Maturity"}
                          <span
                            onClick={() => props.setShowPayment(true)}
                            style={{ cursor: "pointer", fontSize: "15px" }}
                            className="mdi mdi-information-outline ml-1"
                          />
                        </p>
                      </div>
                      <div className="w-40">
                        <p
                          className={
                            "text-align-end " +
                            (!props.isMobile ? "font-size-16" : "navi-font-14")
                          }
                        >
                          {props.priceResponse ? (props.priceResponse?.totalAmountAtMaturity).oroNumber(2, true) : ""}
                        </p>
                      </div>
                    </div>
                    <div className="hr mb-4" />
          {(props?.isNewJourney && !props?.isUserObInvested) ||
          props?.priceResponse?.referralBenefits?.discountInPercForUser ? (
            <div className="d-flex justify-content-between w-100 mb-2">
              <div className="w-60">
                <p className={!props.isMobile ? "font-size-16" : "navi-font-14"}>
                  <img src={giftBox} alt="giftBox-img" />
                  <span className="text-primary"> Offer Benefit</span>
                </p>
              </div>
              <div className="w-40">
                <p
                  className={`text-primary ${!props.isMobile ? "font-size-16" : "navi-font-14"}`}
                  style={{ textAlign: "end" }}
                >
                  {props.isNewJourney && !props.isUserObInvested
                    ? "Upto 0.50"
                    : props.priceResponse?.referralBenefits?.discountInPercForUser?.toFixed(2) || "0"}
                  %
                </p>
              </div>
            </div>
          ) : null}
        </div>
        {!preBookText ? (
          <Button
            className="apply-btn"
            onClick={() => props.startInvest()}
            disabled={props.units < props.minUnit || props.maxAmt || disableInvestButton}
          >
            {getButtonText()}
          </Button>
        ) : (
          <div className="d-flex justify-content-between align-items-center">
            <img
              className="mr-2"
              style={{ height: "35px" }}
              src={`${process.env.REACT_APP_IMAGES_PATH}Clock.webp`}
              alt="clock-img"
            />
            <p className="mb-0">
              Investment Timings{" "}
              <span className="font-weight-semi-bold">
                {`${moment(props.assetDetails?.marketStartTime, "HH:mm").format("hh:mm A")} to ${moment(
                  props.assetDetails?.marketEndTime,
                  "HH:mm"
                ).format("hh:mm A")}, Monday - Friday`}
              </span>
              , Excluding Holidays
            </p>
          </div>
        )}
        <Modal className="enhanced-kyc-modal" isOpen={props.isModalOpen} zIndex={5100}>
          <ModalHeader toggle={props.toggleHvInitiateModal} className="header">
            {props.isMobile && (
              <hr
                onClick={props.toggleHvInitiateModal}
                style={{
                  border: "1px solid #898A8D",
                  borderRadius: "10px",
                  width: "100px",
                  height: "5px",
                  backgroundColor: "#898A8D",
                  cursor: "pointer",
                }}
              ></hr>
            )}
          </ModalHeader>
          <ModalBody className="body">
            <p className="text">Complete your enhanced KYC to continue investing</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button className="apply-btn kyc-btn" onClick={handleCompleteNowClick}>
                Complete Now
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </Col>
  )
)}



              {props?.assetDetails?.category != "historical" && isMobile ?
                <div className="video-div" 
                  onClick={() => handleVideoClick(
                    'https://www.youtube.com/embed/nECRA8wPG5s?autoplay=1&mute=0&rel=0&controls=1&frameborder=0&modestbranding=0&showinfo=0',
                    'What are Corporate Bonds?',
                    'Confused about what corporate bonds are and how they work? In this video, we will break down corporate bonds in simple terms, so you can understand their benefits and how they play a vital role in your investment portfolio.'
                    )}
                >
                    <div className="left-col">
                        <p className="title">New to Corporate Bonds?</p>
                        <p className="subtext">Watch 1-min video to learn how bonds work️</p>
                    </div>
                    <div className="video-col">
                      <div className="video-inner">
                        <img src={process.env.REACT_APP_IMAGES_PATH + (props?.isMobile ? "Video-banner_1.webp" : "Video-banner.webp")} />
                        <div className="circle">
                          <span class="mdi mdi-play"></span>
                        </div>
                      </div>
                    </div>
                </div>
              : null}
          </Row>

          <VideoModal toggleVideoModal={toggleVideoModal} showVideo={showVideo} src={learnVideoSrc} answer={videoAnswer} question={videoQuestion}/>

          {
            props.showMonthlyPayment && 
              <MonthlyPaymentSchedule
                showMonthlyPayment={props.showMonthlyPayment}
                couponsPer1k={props.couponsPer1k}
                closeMonthlyPaymentModal={props.closeMonthlyPaymentModal}
                realisedCouponsSum={props.realisedCouponsSum}
                Coupons={props.Coupons}
                unitPrice={props.unitPrice}
                totalCoupons={props.totalCoupons}
                productDetails={props.productDetails}
                totalNumberCoupons={props.totalPayout}
                units={props.units}
              />
          }

          {!props.isOngoingOrder && !props.loader && props.transactions.length ? (
            <>
              <div ref={props.txnRef} />
              <WLTransactionHistory
                isMobile={props.isMobile}
                transactions={props.transactions}
                portfolio={props.portfolioValue}
                productDetails={props?.productDetails}
              />
            </>
          ) : (
            ""
          )}

          {
            props.productDetails && 
              <UnderstandingAsset
                isMobile={props.isMobile}
                // investNow={props.startInvest}
                assetDetails={props.assetDetails}
                custId={get(props.userProfile, "custId", "")}
                isKycDone={props.isKycDone}
                productDetails={props.productDetails}
                investSectionRef={props.investSectionRef}
                scrollToSection={props.scrollToSection}
                isTxnAllowed={props.isTxnAllowed}
                isDisable={props.isDisable}
              />
          }

          {Object.keys(props.productDetails).length ? (
            <WhyInvestNavi
              isAsset={true}
              isMobile={props.isMobile}
              productDetails={props.productDetails}
              bondDetails={props.bondDetails}
            />
          ) : null}

          <RiskInvolved bondDetails={props.bondDetails} />

          <ResourceFold mldAssetDetails={props.assetDetails} fromBondsPage={true} />
          {props?.showConsultbanner ?
            <ConsultBanner closeConsultBanner={props?.closeConsultBanner} />
            :
            null
          }
          <MldMarketingFaq
            mldMarketingFaq={result && result.length 
              ? result
              : genericFaq}
            isMobile={props.isMobile}
          />

          <Modal
            centered
            isOpen={props.showFAQ}
            toggle={props.closeFAQModal}
            className="modal-md"
            style={props.isMobile ? { marginTop: "15rem", marginBottom: "6rem" } : { marginTop: "10rem", marginBottom: "6rem" }}
          >
            <ModalHeader toggle={props.closeFAQModal} className="pt-3 mt-4"></ModalHeader>
            <ModalBody className="text-center p-4">
              <b className="font-size-12">Current Price is based on the offer applicable for you.</b>
              <div className="mt-4" style={{ textAlign: "left" }}>
                <b className="font-size-12">
                  Q. Why is the price of the bonds on the Bidd platform
                  different from its price on the stock exchange?
                </b>
                <br />
                <br />
                <p className="font-size-12">
                  The current price (Dirty price) of the bond on Bidd may differ
                  from the current price seen on any exchange platform as the price on the
                  exchange is determined by the market action between buyers and sellers.
                  The exchange-based price changes frequently, is volatile, and market-driven.
                  As a result, the returns (XIRR) an investor will earn on their investment will
                  also vary in a similar manner. The price of the bond on Bidd is
                  determined once a day, in a manner that ensures investors earn a fixed return.
                  XIRR on their investment, irrespective of when the investor has purchased the bond.
                </p>
              </div>
              <div className="mt-4" style={{ textAlign: "left" }}>
                <b className="font-size-12">
                  Q. What is the coupon(interest) payment process for the bonds and why
                  does the price of the bond fall on certain days?
                </b>
                <br />
                <br />
                <p className="font-size-12">
                  Investment in the bonds on Bidd offers the opportunity for investors
                  to earn interest on a periodic basis. In other words, the offered bonds pay a
                  monthly/quarterly/half-yearly coupon, as decided and pre-informed by the issuers of
                  the bond . All investors who own the bond as on the 'Record Date' will be eligible for
                  the coupon payment when it is paid out. For example, In case of a particular bond, if
                  the 'Record Date' is 15 working days prior to the interest payment
                  date. i.e.bond issuer locks the list of investors to whom the
                  interest has to be paid fifteen working days prior to the interest
                  payment date.  <br />
                  <br />
                  As a result, the price of the bond falls on the 'Record Date' to
                  reflect the future interest payout. The lower price can also be
                  explained as: a compensation to the investor for holding the bond
                  but not receiving monthly interest for the given month.
                  <br />
                  <br />
                  However to clarify, even after considering these price
                  adjustments, the total returns (XIRR) an investor earns remains
                  constant for the period they are invested into the bond,
                  irrespective of when they purchase the bond.
                </p>
              </div>

              <Button className="mt-4 done-button mb-4" onClick={props.closeFAQModal}>
                Close
              </Button>
            </ModalBody>
          </Modal>

          <Modal
            centered
            isOpen={props.showCleanPrice}
            toggle={props.closeCleanPriceModal}
            className="modal-md"
            style={props.isMobile ? { marginTop: "6rem", marginBottom: "6rem" } : {}}
          >
            <ModalHeader toggle={props.closeCleanPriceModal} className=""></ModalHeader>
            <ModalBody className="text-center">
              <div style={{ textAlign: "center", padding: "1rem" }}>
                <b className="font-size-16">
                  The clean price is the price of a bond excluding accrued interest payments.
                </b>
              </div>
            </ModalBody>
          </Modal>
          <Modal
            centered
            isOpen={props.showPayment}
            toggle={props.closePaymentModal}
            className="modal-md"
          >
            <ModalHeader toggle={props.closePaymentModal} className="pt-3"></ModalHeader>
            <ModalBody className="text-center">
              <div style={{ textAlign: "center", padding: "1rem" }}>
                <b className="font-size-16">
                  Amount to be received till Maturity will be face value of bond
                  (₹{props.productDetails && props.productDetails.faceValue
                    ? utils.indianNumberWithCommasNew(props.productDetails?.faceValue)
                    : ''
                  }/unit) and coupon payment received for the period.
                </b>
              </div>
            </ModalBody>
          </Modal>
          {props.showYTM &&
            <ShowYTMModal
              closeYTMModal={props.closeYTMModal}
              showYTM={props.showYTM}
              currYield={props.currYield}
              assetDetails={props.assetDetails}
              YTM={get(props.priceResponse, "ytm", "")
                ? get(props.priceResponse, "ytm", "").toFixed(2) + "%"
                : ""}
            />
          }
          <Modal
            centered
            isOpen={props.showOfferBenefit}
            toggle={props.closeShowOfferBenefit}
            className="modal-md"
          >
            <ModalHeader toggle={props.closeShowOfferBenefit} className="pt-3"></ModalHeader>
            <ModalBody className="text-center">
              <div style={{ textAlign: "center", padding: "1rem" }}>
                <b className="font-size-16">
                  Offer Benefit is the benefit you are receiving due to the
                  higher investment YTM applicable for you.
                </b>
              </div>
            </ModalBody>
          </Modal>
          <InfoPopup
            showPopUpText={showPopUpText}
            toggleInfoPopup={handleInfoLockedClick}
            text={popUpOverText}
          />
          <InfoPopup
            showPopUpText={showPopUpLotText}
            toggleInfoPopup={handleLotSize}
            text={popUpOverLotText}
          />
        </div> : <OroLoader />
      }
      <ToastContainer />
    </>
  )
});

export default BondsAsset;